__turbopack_context__.v({
  "amethyst": "text-colors-module-scss-module__QlUAxW__amethyst",
  "amethyst--lg": "text-colors-module-scss-module__QlUAxW__amethyst--lg",
  "amethyst--md": "text-colors-module-scss-module__QlUAxW__amethyst--md",
  "amethyst--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__amethyst--modal-button-layout-shift",
  "amethyst--sm": "text-colors-module-scss-module__QlUAxW__amethyst--sm",
  "amethyst--tablet": "text-colors-module-scss-module__QlUAxW__amethyst--tablet",
  "amethyst--xl": "text-colors-module-scss-module__QlUAxW__amethyst--xl",
  "amethyst--xs": "text-colors-module-scss-module__QlUAxW__amethyst--xs",
  "amethyst--xxs": "text-colors-module-scss-module__QlUAxW__amethyst--xxs",
  "apricot": "text-colors-module-scss-module__QlUAxW__apricot",
  "apricot--lg": "text-colors-module-scss-module__QlUAxW__apricot--lg",
  "apricot--md": "text-colors-module-scss-module__QlUAxW__apricot--md",
  "apricot--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__apricot--modal-button-layout-shift",
  "apricot--sm": "text-colors-module-scss-module__QlUAxW__apricot--sm",
  "apricot--tablet": "text-colors-module-scss-module__QlUAxW__apricot--tablet",
  "apricot--xl": "text-colors-module-scss-module__QlUAxW__apricot--xl",
  "apricot--xs": "text-colors-module-scss-module__QlUAxW__apricot--xs",
  "apricot--xxs": "text-colors-module-scss-module__QlUAxW__apricot--xxs",
  "background": "text-colors-module-scss-module__QlUAxW__background",
  "background--lg": "text-colors-module-scss-module__QlUAxW__background--lg",
  "background--md": "text-colors-module-scss-module__QlUAxW__background--md",
  "background--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__background--modal-button-layout-shift",
  "background--sm": "text-colors-module-scss-module__QlUAxW__background--sm",
  "background--tablet": "text-colors-module-scss-module__QlUAxW__background--tablet",
  "background--xl": "text-colors-module-scss-module__QlUAxW__background--xl",
  "background--xs": "text-colors-module-scss-module__QlUAxW__background--xs",
  "background--xxs": "text-colors-module-scss-module__QlUAxW__background--xxs",
  "black": "text-colors-module-scss-module__QlUAxW__black",
  "black--lg": "text-colors-module-scss-module__QlUAxW__black--lg",
  "black--md": "text-colors-module-scss-module__QlUAxW__black--md",
  "black--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__black--modal-button-layout-shift",
  "black--sm": "text-colors-module-scss-module__QlUAxW__black--sm",
  "black--tablet": "text-colors-module-scss-module__QlUAxW__black--tablet",
  "black--xl": "text-colors-module-scss-module__QlUAxW__black--xl",
  "black--xs": "text-colors-module-scss-module__QlUAxW__black--xs",
  "black--xxs": "text-colors-module-scss-module__QlUAxW__black--xxs",
  "black-v2": "text-colors-module-scss-module__QlUAxW__black-v2",
  "black-v2--lg": "text-colors-module-scss-module__QlUAxW__black-v2--lg",
  "black-v2--md": "text-colors-module-scss-module__QlUAxW__black-v2--md",
  "black-v2--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__black-v2--modal-button-layout-shift",
  "black-v2--sm": "text-colors-module-scss-module__QlUAxW__black-v2--sm",
  "black-v2--tablet": "text-colors-module-scss-module__QlUAxW__black-v2--tablet",
  "black-v2--xl": "text-colors-module-scss-module__QlUAxW__black-v2--xl",
  "black-v2--xs": "text-colors-module-scss-module__QlUAxW__black-v2--xs",
  "black-v2--xxs": "text-colors-module-scss-module__QlUAxW__black-v2--xxs",
  "coal-mine-canary": "text-colors-module-scss-module__QlUAxW__coal-mine-canary",
  "coal-mine-canary--lg": "text-colors-module-scss-module__QlUAxW__coal-mine-canary--lg",
  "coal-mine-canary--md": "text-colors-module-scss-module__QlUAxW__coal-mine-canary--md",
  "coal-mine-canary--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__coal-mine-canary--modal-button-layout-shift",
  "coal-mine-canary--sm": "text-colors-module-scss-module__QlUAxW__coal-mine-canary--sm",
  "coal-mine-canary--tablet": "text-colors-module-scss-module__QlUAxW__coal-mine-canary--tablet",
  "coal-mine-canary--xl": "text-colors-module-scss-module__QlUAxW__coal-mine-canary--xl",
  "coal-mine-canary--xs": "text-colors-module-scss-module__QlUAxW__coal-mine-canary--xs",
  "coal-mine-canary--xxs": "text-colors-module-scss-module__QlUAxW__coal-mine-canary--xxs",
  "cold-steel": "text-colors-module-scss-module__QlUAxW__cold-steel",
  "cold-steel--lg": "text-colors-module-scss-module__QlUAxW__cold-steel--lg",
  "cold-steel--md": "text-colors-module-scss-module__QlUAxW__cold-steel--md",
  "cold-steel--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__cold-steel--modal-button-layout-shift",
  "cold-steel--sm": "text-colors-module-scss-module__QlUAxW__cold-steel--sm",
  "cold-steel--tablet": "text-colors-module-scss-module__QlUAxW__cold-steel--tablet",
  "cold-steel--xl": "text-colors-module-scss-module__QlUAxW__cold-steel--xl",
  "cold-steel--xs": "text-colors-module-scss-module__QlUAxW__cold-steel--xs",
  "cold-steel--xxs": "text-colors-module-scss-module__QlUAxW__cold-steel--xxs",
  "cyanora": "text-colors-module-scss-module__QlUAxW__cyanora",
  "cyanora--lg": "text-colors-module-scss-module__QlUAxW__cyanora--lg",
  "cyanora--md": "text-colors-module-scss-module__QlUAxW__cyanora--md",
  "cyanora--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__cyanora--modal-button-layout-shift",
  "cyanora--sm": "text-colors-module-scss-module__QlUAxW__cyanora--sm",
  "cyanora--tablet": "text-colors-module-scss-module__QlUAxW__cyanora--tablet",
  "cyanora--xl": "text-colors-module-scss-module__QlUAxW__cyanora--xl",
  "cyanora--xs": "text-colors-module-scss-module__QlUAxW__cyanora--xs",
  "cyanora--xxs": "text-colors-module-scss-module__QlUAxW__cyanora--xxs",
  "dark-gray": "text-colors-module-scss-module__QlUAxW__dark-gray",
  "dark-gray--lg": "text-colors-module-scss-module__QlUAxW__dark-gray--lg",
  "dark-gray--md": "text-colors-module-scss-module__QlUAxW__dark-gray--md",
  "dark-gray--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__dark-gray--modal-button-layout-shift",
  "dark-gray--sm": "text-colors-module-scss-module__QlUAxW__dark-gray--sm",
  "dark-gray--tablet": "text-colors-module-scss-module__QlUAxW__dark-gray--tablet",
  "dark-gray--xl": "text-colors-module-scss-module__QlUAxW__dark-gray--xl",
  "dark-gray--xs": "text-colors-module-scss-module__QlUAxW__dark-gray--xs",
  "dark-gray--xxs": "text-colors-module-scss-module__QlUAxW__dark-gray--xxs",
  "default": "text-colors-module-scss-module__QlUAxW__default",
  "default--lg": "text-colors-module-scss-module__QlUAxW__default--lg",
  "default--md": "text-colors-module-scss-module__QlUAxW__default--md",
  "default--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__default--modal-button-layout-shift",
  "default--sm": "text-colors-module-scss-module__QlUAxW__default--sm",
  "default--tablet": "text-colors-module-scss-module__QlUAxW__default--tablet",
  "default--xl": "text-colors-module-scss-module__QlUAxW__default--xl",
  "default--xs": "text-colors-module-scss-module__QlUAxW__default--xs",
  "default--xxs": "text-colors-module-scss-module__QlUAxW__default--xxs",
  "dim": "text-colors-module-scss-module__QlUAxW__dim",
  "dim--lg": "text-colors-module-scss-module__QlUAxW__dim--lg",
  "dim--md": "text-colors-module-scss-module__QlUAxW__dim--md",
  "dim--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__dim--modal-button-layout-shift",
  "dim--sm": "text-colors-module-scss-module__QlUAxW__dim--sm",
  "dim--tablet": "text-colors-module-scss-module__QlUAxW__dim--tablet",
  "dim--xl": "text-colors-module-scss-module__QlUAxW__dim--xl",
  "dim--xs": "text-colors-module-scss-module__QlUAxW__dim--xs",
  "dim--xxs": "text-colors-module-scss-module__QlUAxW__dim--xxs",
  "future-fuscia": "text-colors-module-scss-module__QlUAxW__future-fuscia",
  "future-fuscia--lg": "text-colors-module-scss-module__QlUAxW__future-fuscia--lg",
  "future-fuscia--md": "text-colors-module-scss-module__QlUAxW__future-fuscia--md",
  "future-fuscia--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__future-fuscia--modal-button-layout-shift",
  "future-fuscia--sm": "text-colors-module-scss-module__QlUAxW__future-fuscia--sm",
  "future-fuscia--tablet": "text-colors-module-scss-module__QlUAxW__future-fuscia--tablet",
  "future-fuscia--xl": "text-colors-module-scss-module__QlUAxW__future-fuscia--xl",
  "future-fuscia--xs": "text-colors-module-scss-module__QlUAxW__future-fuscia--xs",
  "future-fuscia--xxs": "text-colors-module-scss-module__QlUAxW__future-fuscia--xxs",
  "negative": "text-colors-module-scss-module__QlUAxW__negative",
  "primary": "text-colors-module-scss-module__QlUAxW__primary",
  "primary--lg": "text-colors-module-scss-module__QlUAxW__primary--lg",
  "primary--md": "text-colors-module-scss-module__QlUAxW__primary--md",
  "primary--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__primary--modal-button-layout-shift",
  "primary--sm": "text-colors-module-scss-module__QlUAxW__primary--sm",
  "primary--tablet": "text-colors-module-scss-module__QlUAxW__primary--tablet",
  "primary--xl": "text-colors-module-scss-module__QlUAxW__primary--xl",
  "primary--xs": "text-colors-module-scss-module__QlUAxW__primary--xs",
  "primary--xxs": "text-colors-module-scss-module__QlUAxW__primary--xxs",
  "secondary": "text-colors-module-scss-module__QlUAxW__secondary",
  "secondary--lg": "text-colors-module-scss-module__QlUAxW__secondary--lg",
  "secondary--md": "text-colors-module-scss-module__QlUAxW__secondary--md",
  "secondary--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__secondary--modal-button-layout-shift",
  "secondary--sm": "text-colors-module-scss-module__QlUAxW__secondary--sm",
  "secondary--tablet": "text-colors-module-scss-module__QlUAxW__secondary--tablet",
  "secondary--xl": "text-colors-module-scss-module__QlUAxW__secondary--xl",
  "secondary--xs": "text-colors-module-scss-module__QlUAxW__secondary--xs",
  "secondary--xxs": "text-colors-module-scss-module__QlUAxW__secondary--xxs",
  "springtime": "text-colors-module-scss-module__QlUAxW__springtime",
  "springtime--lg": "text-colors-module-scss-module__QlUAxW__springtime--lg",
  "springtime--md": "text-colors-module-scss-module__QlUAxW__springtime--md",
  "springtime--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__springtime--modal-button-layout-shift",
  "springtime--sm": "text-colors-module-scss-module__QlUAxW__springtime--sm",
  "springtime--tablet": "text-colors-module-scss-module__QlUAxW__springtime--tablet",
  "springtime--xl": "text-colors-module-scss-module__QlUAxW__springtime--xl",
  "springtime--xs": "text-colors-module-scss-module__QlUAxW__springtime--xs",
  "springtime--xxs": "text-colors-module-scss-module__QlUAxW__springtime--xxs",
  "success": "text-colors-module-scss-module__QlUAxW__success",
  "tertiary": "text-colors-module-scss-module__QlUAxW__tertiary",
  "tertiary--lg": "text-colors-module-scss-module__QlUAxW__tertiary--lg",
  "tertiary--md": "text-colors-module-scss-module__QlUAxW__tertiary--md",
  "tertiary--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__tertiary--modal-button-layout-shift",
  "tertiary--sm": "text-colors-module-scss-module__QlUAxW__tertiary--sm",
  "tertiary--tablet": "text-colors-module-scss-module__QlUAxW__tertiary--tablet",
  "tertiary--xl": "text-colors-module-scss-module__QlUAxW__tertiary--xl",
  "tertiary--xs": "text-colors-module-scss-module__QlUAxW__tertiary--xs",
  "tertiary--xxs": "text-colors-module-scss-module__QlUAxW__tertiary--xxs",
});
